import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../services/api";

export default function DocumentDetail() {
  const { id } = useParams();
  const [doc, setDoc] = useState(null);
  const [hashResult, setHashResult] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");

    api
      .get(`/document?id=${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setDoc(res.data))
      .catch(() => alert("Access Denied"));
  }, [id]);

  if (!doc)
    return (
      <div className="p-10 text-center text-gray-500">
        Loading document...
      </div>
    );

  const role = localStorage.getItem("role");
  const status = doc.document.status;
  const docType = doc.document.doc_type;

  const verifyDocument = async () => {
    const token = localStorage.getItem("accessToken");

    try {
      await api.post(
        "/audit/verify",
        {},
        {
          params: { po_id: id },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      alert("Verified successfully");
      window.location.reload();
    } catch {
      alert("Verification failed");
    }
  };

  const verifyHash = async () => {
    const token = localStorage.getItem("accessToken");

    try {
      const res = await api.get(
        `/verify-hash?document_id=${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setHashResult(res.data);
    } catch {
      alert("Hash verification failed");
    }
  };

  const docIcon = (type) => {
    if (type === "PO") return "📝";
    if (type === "BOL") return "📦";
    if (type === "INVOICE") return "🧾";
    if (type === "LOC") return "🏦";
    return "📄";
  };

  const actionDot = (action) => {
    if (action === "ISSUED") return "bg-blue-500";
    if (action === "SHIPPED") return "bg-orange-500";
    if (action === "RECEIVED") return "bg-green-500";
    if (action === "VERIFIED") return "bg-purple-500";
    if (action === "PAID") return "bg-emerald-500";
    return "bg-gray-400";
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow p-6 space-y-8 border-l-4 border-gray-400">

        {/* Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="text-3xl">{docIcon(docType)}</span>
            <div>
              <h2 className="text-2xl font-bold">
                {doc.document.doc_number}
              </h2>
              <p className="text-sm text-gray-500">
                {docType} Document
              </p>
            </div>
          </div>

          <span className="px-3 py-1 rounded-full text-sm font-semibold bg-gray-100">
            {status}
          </span>
        </div>

        {/* Auditor Verify */}
        {role === "auditor" && docType === "PO" && status !== "VERIFIED" && (
          <button
            onClick={verifyDocument}
            className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
          >
            🔍 Verify PO + LOC
          </button>
        )}

        {/* File Section */}
        <div>
          <h3 className="text-lg font-semibold mb-3">📂 File</h3>

          <div className="flex gap-3">
            <a
              href={doc.document.file_url}
              target="_blank"
              rel="noreferrer"
              className="px-4 py-2 bg-sky-500 text-white rounded-lg hover:bg-sky-600"
            >
              Open File
            </a>

            <button
              onClick={verifyHash}
              className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
            >
              Verify Integrity
            </button>
          </div>

          {hashResult && (
            <div className="mt-4 p-4 rounded-lg border bg-slate-50">
              <p className="text-xs font-mono">
                Stored: {hashResult.stored_hash}
              </p>
              <p className="text-xs font-mono">
                Current: {hashResult.recalculated_hash}
              </p>

              {hashResult.is_valid ? (
                <p className="text-green-700 mt-2">
                  ✅ Hash matched
                </p>
              ) : (
                <p className="text-red-700 mt-2">
                  ❌ Hash mismatch
                </p>
              )}
            </div>
          )}
        </div>

        {/* Ledger */}
        <div>
          <h3 className="text-lg font-semibold mb-3">
            🧾 Ledger Timeline
          </h3>

          <div className="relative border-l-2 border-gray-300 pl-6 space-y-6">
            {doc.ledger.map((entry, index) => (
              <div key={index} className="relative">
                <span
                  className={`absolute -left-[9px] top-1.5 w-4 h-4 rounded-full ${actionDot(entry.action)}`}
                ></span>

                <div className="bg-white p-4 rounded-lg shadow-sm">
                  <p className="font-medium">{entry.action}</p>
                  <p className="text-sm text-gray-700">
                    By {entry.actor_name} ({entry.actor_role})
                  </p>
                  <p className="text-xs text-gray-500">
                    {new Date(entry.created_at).toLocaleString()}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}